// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"7b110f86a186cfb5","931":"7ce4a84abd62851b"}[chunkId] + ".css";
};